//delete draft answer in localStorage
const deleteDraftAnswer = (questions) => {
    if (questions) {
        questions.forEach((question) => {
            ['idTextAnswer', 'idAnotherAnswer', 'timeAudioRan', 'timeVideoRan', `timeVideoRanDuration`] //first key localStorage
                .forEach((firstKeyLocalStorage) => {
                    const keyLocalStorage = `${firstKeyLocalStorage}${question.questionCode}`;
                    if (localStorage.getItem(keyLocalStorage)) {
                        localStorage.removeItem(keyLocalStorage);
                    }
                });
            if (question.questions) {
                question.questions.forEach((question) => {
                    ['idTextAnswer', 'idAnotherAnswer', 'timeAudioRan', 'timeVideoRan', `timeVideoRanDuration`] //first key localStorage
                        .forEach((firstKeyLocalStorage) => {
                            const keyLocalStorage = `${firstKeyLocalStorage}${question.questionCode}`;
                            if (localStorage.getItem(keyLocalStorage)) {
                                localStorage.removeItem(keyLocalStorage);
                            }
                        });
                });
            }
        });
    }
};

export default deleteDraftAnswer;
